import './components/video.scss';
import { createExercise } from '@datacamp/campus-integration';
import { constants, utils } from '@datacamp/video-exercise-core';
import setExerciseEntity from './actions/actionCreators/exerciseEntityUpdated';
import config from './config';
import { VideoExerciseCompatibilityWrapper } from './containers/VideoExerciseCompatibilityWrapper';
import { sentry } from './lib/sentry';
import commonDe from './locales/de-DE/common.json';
import de from './locales/de-DE/translation.json';
import commonEn from './locales/en/common.json';
import en from './locales/en/translation.json';
import commonEs from './locales/es/common.json';
import es from './locales/es/translation.json';
import commonFr from './locales/fr-FR/common.json';
import fr from './locales/fr-FR/translation.json';
import commonIt from './locales/it-IT/common.json';
import it from './locales/it-IT/translation.json';
import commonPt from './locales/pt-BR/common.json';
import pt from './locales/pt-BR/translation.json';
import commonTr from './locales/tr-TR/common.json';
import tr from './locales/tr-TR/translation.json';
import store from './store';
const App = createExercise({
  config,
  requireAuthenticatedUser: false,
  sentryInstance: sentry,
  setExerciseEntity,
  store,
  translations: {
    de: {
      common: commonDe,
      translation: de
    },
    en: {
      common: commonEn,
      translation: en
    },
    es: {
      common: commonEs,
      translation: es
    },
    fr: {
      common: commonFr,
      translation: fr
    },
    it: {
      common: commonIt,
      translation: it
    },
    pt: {
      common: commonPt,
      translation: pt
    },
    tr: {
      common: commonTr,
      translation: tr
    }
  },
  type: constants.exercises.VIDEO_EXERCISE,
  validate: utils.exerciseTypeVersionAdapter
})(VideoExerciseCompatibilityWrapper);
export default App;